<script>
    export let params = {id}

    import SubPageHeader from '../components/SubPageHeader.svelte'
    import { translations, current_lang, news_api_storage } from '../stores.js';
    import { afterUpdate } from 'svelte';
    import WaitingPlaceholderBox from '../components/WaitingPlaceholderBox.svelte'

    let news = null;

    let article_date 

    let article;

    function find_article(article_id) {
        news = $news_api_storage;
        //console.log(news);
        if(news != null){
            if($current_lang == "FI"){
                article = news.fi.find(x => x.id === parseInt(article_id));

            }
            if($current_lang == "EN"){
                article = news.en.find(x => x.id === parseInt(article_id));
            }

            if(article == undefined){
                throw new Error("Article not found");
            }

            if(article != null){
                article_date = article.date;
            }
        }
    }

    let image_load = null;
    afterUpdate(() => {
        find_article(params.id);

        image_load = image_get();
    });

    let img_class = "";

    async function image_get() { 
        if(!article){
            return;
        }
        if((article.mobilePictureUrl == null || article.mobilePictureUrl == "") && (article.fullPictureUrl == null || article.fullPictureUrl == "")){
            return;
        }

        const img = new Image();

        //console.log(article);

        if(article.mobilePictureUrl != null && article.mobilePictureUrl != ""){
            img.src = article.mobilePictureUrl;
        }else if(article.fullPictureUrl != null){
            img.src = article.fullPictureUrl;
            img_class = "wide";
        }

        const res = await img.decode()
        .then(() => {
            return img.src;
        })
        .catch((encodingError) => {
            // Do something with the error.
        })

        return res;
    }
</script>

<SubPageHeader page_title={$translations["NEWS"][$current_lang]} />
{#if news != null}
    {#if article != null}
        <div class="content-container full">
            {#if (article.mobilePictureUrl != null && article.mobilePictureUrl != "") || (article.fullPictureUrl != null && article.fullPictureUrl != "")}
                {#await image_load}
                    <WaitingPlaceholderBox height={180} margin_bottom={0} />
                {:then img_src}
                    {#if img_src != null && img_src != ""}
                        <img class="article-main-picture {img_class}" src="{img_src}" alt="{article.title}">
                    {/if}
                {:catch error}
                    <p>{error}</p>
                {/await}
            {/if}

            <div class="inner-padding-container">
                <div class="article-date-row">
                    <span class="article-date">{article_date}</span>
                </div>
                <h2>{article.title}</h2>
                {@html article.content}
            </div>
        </div>
    {/if}
{/if}

<style>
.article-date-row{
    margin-bottom: 15px;
}
h2{
    font-size: 1.6rem;
}
.article-main-picture{
    width: auto;
    aspect-ratio: 1 / 1;
}

.article-main-picture.wide{
    width: auto;
    aspect-ratio: initial;
}
</style>